
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_25476_43302)"}},[_c('path',{attrs:{"d":"M15.679 9.295l-4.709 6.286-3.143-2.354M5.964 5.867a2.571 2.571 0 100-5.143 2.571 2.571 0 000 5.143zM3.678 14.438H.821v-1.714A5.143 5.143 0 019.598 9.09"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_43302"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.25 .152)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    